// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"terms-of-service_wrapper__6vIE2","header":"terms-of-service_header__2J33R","active":"terms-of-service_active__2iUkP","body":"terms-of-service_body__2Ij8u"};